import { Title } from "../typography"

export interface StyledButtonProps {
	style?: string
	title?: string
	disabled?: boolean
	onClick: () => void
	children?: React.ReactNode
}

export const StyledButton = ({ style, title, disabled, children, onClick }: StyledButtonProps) => {
	return (
		<div className={`cursor-pointer ${style ?? ""}`} onClick={disabled ? undefined : onClick}>
			{title ? <Title>{title}</Title> : children}
		</div>
	)
}
